


















































import { Component } from 'vue-property-decorator';
import RouterHelper from '@shared/helpers/router.helper';
import gsap from 'gsap';
import HomeSection from './Section.abstract';

const routerHelper = new RouterHelper();

@Component
export default class HomeStat extends HomeSection {
  public statNumbers: { [key: string]: number } = {
    libraries: 0,
    hours: 0,
    bundles: 0,
    librariesFinal: 47,
    hoursFinal: 500,
    bundlesFinal: 25,
  };

  headersAppearence = true;

  headersRefs = {
    header: 'header',
  };

  get libraries(): string {
    return this.statNumbers.libraries.toFixed(0);
  }

  get hours(): string {
    return this.statNumbers.hours
      .toFixed(0)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  get bundles(): string {
    return this.statNumbers.bundles.toFixed(0);
  }

  mounted(): void {
    this.startCounting();
    window.addEventListener('scroll', this.initCounting.bind(this));
  }

  destroyed(): void {
    window.removeEventListener('scroll', this.initCounting.bind(this));
  }

  initCounting(): void {
    this.startCounting();
  }

  private startCounting(): void {
    const section: HTMLDivElement = this.$refs.statBlock as HTMLDivElement;
    if (!section) return;
    const { top, bottom } = section.getBoundingClientRect() as DOMRect;

    const isVisible: boolean =
      top >= 100 &&
      bottom <= (window.innerHeight || document.documentElement.clientHeight);

    if (isVisible) {
      gsap.to(this.statNumbers, {
        duration: 1,
        libraries: this.statNumbers.librariesFinal,
      });
      gsap.to(this.statNumbers, {
        duration: 1,
        hours: this.statNumbers.hoursFinal,
      });
      gsap.to(this.statNumbers, {
        duration: 1,
        bundles: this.statNumbers.bundlesFinal,
      });
    }
  }

  signup() {
    this.$router.push(routerHelper.signup().getRoute());
  }
}
